import { render, staticRenderFns } from "./UserActivityTable.vue?vue&type=template&id=4b60faec&scoped=true&"
import script from "./UserActivityTable.vue?vue&type=script&lang=js&"
export * from "./UserActivityTable.vue?vue&type=script&lang=js&"
import style0 from "./UserActivityTable.vue?vue&type=style&index=0&id=4b60faec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b60faec",
  null
  
)

export default component.exports